import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { PermissionString } from "../auth/types";
import { getUserPlatformPermissions } from "../portal-api";
import { getQueryKeyForOrganization } from "./useActiveOrganizationQuery";

export function useUserPlatformPermissionsQuery(
  userId: number | undefined,
  organizationId: number | undefined,
  options: Partial<UseQueryOptions<PermissionString[]>> = {},
) {
  return useQuery<PermissionString[]>({
    queryKey: [
      ...getQueryKeyForOrganization(organizationId),
      "users",
      userId,
      "platform-permissions",
    ],
    queryFn: () => {
      if (!userId) throw Error("User not found");
      if (!organizationId) throw Error("Organization not found");
      return getUserPlatformPermissions(userId, organizationId);
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!userId && !!organizationId,
    ...options,
  });
}
